// I copied this file mostly from modal; the biggest difference is that the size
// of the modal is increased to hold more content
import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Global, css } from '@emotion/core';

import {
  BoxShadow,
  TransitionGlobal,
  Gutter,
} from '../../../shared/GlobalStyles';

const ModalStyle = {
  overlay: {
    alignItems: 'center',
    backgroundColor: 'rgba(216, 216, 216, 0.5)',
    display: 'flex',
    height: '100vh',
    position: 'fixed',
    top: '0',
    width: '100vw',
    zIndex: '100',
  },
  content: {
    backgroundColor: '#222',
    borderRadius: '24px',
    boxShadow: `${BoxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Nunito Sans',
    maxWidth: '680px',
    width: '90vw',
  },
};

export const ModalContentWrapper = styled('div')`
  background-color: ${(props) => props.theme.backgroundColorL2};
  display: flex;
  flex-grow: 1;
  form {
    padding-bottom: 20px;
    label {
      color: ${(props) => props.theme.textColor};
    }
    input, textarea {
      background-color: ${(props) => props.theme.backgroundColorL3};
    }
  }
  .form-group {
    padding: ${Gutter} calc(${Gutter} * 3);
  }
  .modal-button {
    bottom: 0;
    margin-left: -40px;
    position: absolute;
  }
  .react-pdf__Page__canvas {
    margin: 0 auto;
  }
  .select__control, .select__menu, textarea {
    background-color: ${(props) => props.theme.backgroundColorL3};
    border-color: ${(props) => props.theme.noBorderColorForm};
    color: ${(props) => props.theme.textColor};
  }
  .select__single-value {
    color: ${(props) => props.theme.textColor};
  }
  .spinner-container {
    min-height: 300px;
  }
  @media only screen and (min-height: 581px) and (max-height : 768px) {
    .modal-button {
      margin-left: -20px;
    }
    .title-container {
      margin-bottom: 0px;
    }
  }
  @media only screen and (max-height : 580px) {
    .modal-button {
      margin-left: -20px;
    }
    .title-container {
      display: none;
    }
  }
  @media only screen and (max-width: 1024px) {
    .note-title-container {
      margin-bottom: 0px!important;
    }
  }
`;

const MediaModalWrapper = ({
  children,
  isOpen,
  onRequestClose,
}) => {
  const modalClose = () => {
    onRequestClose();
  };

  return (
    <>
      <Global
        styles={css`
          .ReactModal__Content {
            opacity: 0;
            transform: translateY(50%);
            &:focus {
              outline: -webkit-focus-ring-color auto 0px!important;
            }
          }
          .ReactModal__Overlay {
            background-color: rgba(216, 216, 216, 0.5);
            opacity: 1;
            z-index: 1000!important;
            justify-content: center;
          }
          .ReactModal__Overlay--after-open {
            opacity: 1;
            transition: ${TransitionGlobal};
          }
          .ReactModal__Overlay--before-close {
            opacity: 0;
          }
          .ReactModal__Content--after-open {
            opacity: 1;
            transform: translateY(0);
            transition: ${TransitionGlobal};
          }
          .ReactModal__Content--before-close {
            opacity: 0;
            transform: translateY(50%);
          }
          @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
            .ReactModal__Content {
              width: 75vw!important;
            } 
          }
          @media only screen and (max-device-width: 767px) {
            .ReactModal__Content {
              min-width: 95%!important;
            }
          }
        `}
      />
      <ReactModal
        closeTimeoutMS={250}
        isOpen={!!isOpen}
        onRequestClose={modalClose}
        style={ModalStyle}
        className='global-modal'
        overlayClassName='overlay'
      >
        <ModalContentWrapper>
          {children}
        </ModalContentWrapper>
      </ReactModal>
    </>
  );
};

if (process.env.STORYBOOK_RUNNING === undefined) {
  ReactModal.setAppElement('#app');
}

export default MediaModalWrapper;

MediaModalWrapper.propTypes = {
  children: PropTypes.node,
  onRequestClose: PropTypes.func.isRequired,
  isOpen: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
};

MediaModalWrapper.defaultProps = {
  children: '',
};
